import * as React from 'react';
import { EditMode } from '../types';
import { WorkflowWebhookEditor } from './WorkflowWebhookEditor';
import { WorkflowWebhookInfo } from './WorkflowWebhookInfo';
import { WorkflowWebhookRequest } from './WorkflowWebhookRequest';
import {
  Container,
  Section,
  Header,
  Hint,
  Content,
  NamePanel,
  Hr,
} from './WorkflowWebhookDetails.styled';

import type { WorkflowWebhook } from '../types';

type Props = {
  webhook: WorkflowWebhook;
  onUpdate: (webhook: WorkflowWebhook) => void;
  onSave: (webhook: WorkflowWebhook) => void;
  onCancel?: () => void;
};

export const WorkflowWebhookDetails = ({ webhook, onUpdate, onSave, onCancel }: Props) => {
  const [editingName, setEditingName] = React.useState(false);
  const [editingWebhook, setEditingWebhook] = React.useState(false);

  return (
    <Container>
      <Section>
        <div>
          <Header>Details</Header>
        </div>
        <NamePanel isEditing={editingName}>
          {editingName ? (
            <WorkflowWebhookEditor
              mode={EditMode.EditName}
              webhook={webhook}
              onUpdate={onUpdate}
              onSave={(updatedHook) => {
                setEditingName(false);
                onSave(updatedHook);
              }}
              onCancel={() => {
                setEditingName(false);
                onCancel?.();
              }}
            />
          ) : (
            <WorkflowWebhookInfo webhook={webhook} onEdit={() => setEditingName(true)} />
          )}
        </NamePanel>
      </Section>
      <Hr />
      <Section>
        <div>
          <Header>Request</Header>
          <Hint>
            <p>
              Specify where to send the request, how to authenticate (OAuth 2.0, Basic, or custom
              headers), and what data to include in the payload.
            </p>
            <p>
              Use Handlebars to reference dynamic data in the endpoint, custom headers and payload
              (JSON or URL-encoded form).
            </p>
          </Hint>
        </div>
        <Content>
          {editingWebhook ? (
            <WorkflowWebhookEditor
              mode={EditMode.EditWebhook}
              webhook={webhook}
              onUpdate={onUpdate}
              onSave={(updatedHook) => {
                setEditingWebhook(false);
                onSave(updatedHook);
              }}
              onCancel={() => {
                setEditingWebhook(false);
                onCancel?.();
              }}
            />
          ) : (
            <WorkflowWebhookRequest webhook={webhook} onEdit={() => setEditingWebhook(true)} />
          )}
        </Content>
      </Section>
    </Container>
  );
};
